import { Platform } from 'react-native';
import {
  BodyText,
  TBodyTextProps,
} from '@/common/components/BodyText/BodyText';
import { Label } from '@/common/components/Label/Label';
import { canOpenURL, openURL } from 'expo-linking';

export type TTextActionProps = {
  type?: 'label' | 'text';
} & TBodyTextProps;

export function TextAction({ type = 'text', ...props }: TTextActionProps) {
  const Parent = type === 'label' ? Label : BodyText;
  return (
    <Parent
      {...props}
      onPress={async (evt) => {
        props.onPress?.(evt);
        if (Platform.OS !== 'web' && props.href) {
          const canOpen = await canOpenURL(props.href);
          if (canOpen) {
            openURL(props.href);
          }
        }
      }}
      bold
      underline
    />
  );
}
